import { nextTick, ref } from 'vue'
import useModal from '@/composables/modal'
import { useLockedRecords } from '@/modules/custom-table/composables/useLockedRecords'

type WidgetModalState = {
    opened: boolean
    token?: string
    recordId?: string
    workflowName?: string
}

const INITIAL_STATE: WidgetModalState = {
    opened: false,
}

const widgetModalState = ref<WidgetModalState>({ ...INITIAL_STATE })

const closeWidgetModal = () => {
    widgetModalState.value = { ...INITIAL_STATE }
}

const openWidgetModal = async (props: { token: string, workflowName: string, recordId?: string }) => {
    const { confirmModal } = useModal()
    const { unlockRecord } = useLockedRecords()

    if (widgetModalState.value.opened) {
        try {
            await confirmModal({
                title: 'Are you sure you want to open a new workflow?',
                description: 'The current workflow will be closed.',
            })
        } catch (error) {
            // The record is locked earlier,
            // but this specifically covers the case where a workflow is started on record A
            // and the user later clicks the restart workflow button on record B.
            // In that scenario, the lock is already in place,
            // so it is released here (note that this comes from props, not from the modal state).
            unlockRecord(props.recordId)

            // eslint-disable-next-line no-console
            console.warn('Opening widget modal cancelled by user.', error)

            return
        }
    }

    closeWidgetModal()

    nextTick(() => {
        widgetModalState.value = {
            opened: true,
            token: props.token,
            recordId: props.recordId,
            workflowName: props.workflowName,
        }
    })
}


const useWidgetModal = () => ({
    widgetModalState,
    openWidgetModal,
    closeWidgetModal,
})

export default useWidgetModal
